import { createReducer, on } from '@ngrx/store';
import { ConfiguredApplicationsApiActions } from './device-configured-applications.actions';
import { adapter, initialState } from './device-configured-applications.state';

export const deviceConfiguredApplicationsReducer = createReducer(
  initialState,
  on(ConfiguredApplicationsApiActions.configuredApplicationsLoaded, (state, { configuredApplications }) =>
    adapter.upsertMany(configuredApplications, state)
  )
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectDeviceConfiguredApplicationsIds = selectIds;

export const selectDeviceConfiguredApplicationsEntities = selectEntities;

export const selectDeviceConfiguredApplications = selectAll;
